module.exports = __webpack_public_path__ + "static/media/check_sense.3e697b33.png";